<template>
  <RestrictionChangePlanModal
    :title="isUpgradePlan
      ? 'Realiza un upgrade y accede a todo el poder de Beex.'
      : 'Obtén esta funcionalidad personalizando tu plan.'
    "
    v-if="open"
    :open="open"
    @update:open="emit('update:open', $event)"
    :planRequest="plan ?? undefined"
    :advisorOnly="advisorOnly"
    :requestButtonLabel="isUpgradePlan ? 'Upgrade All in One' : 'Personalizar plan'"
  >
    <template #description v-if="isUpgradePlan">
      Tu plan {{ planName }} no incluye esta funcionalidad. <br />
      Solicita un upgrade y potencia tu ambiente de trabajo.
      ¡Que tu viaje no se detenga!
    </template>
    <template #body v-else-if="isSpecialPlan">
      <p>
        Tu plan no incluye esta funcionalidad.<br />
        Contacta a un asesor de ventas y solicita personalizar tu plan para potenciar tu ambiente de trabajo.
      </p>
      <p>
        {{
          isClientBeexcc
            ? "Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨"
            : "Aprovecha al máximo todo lo que puedes lograr con BeexCC. ¡Lleva tu experiencia más lejos! ✨"
        }}
      </p>
    </template>
    <template #body v-else>
      <p>
        Tu plan {{ planName }} no incluye esta funcionalidad.<br />
        Solicita personalizar tu plan para potenciar tu ambiente de trabajo.
      </p>
      <p>
        {{
          isClientBeexcc
            ? "Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨"
            : "Aprovecha al máximo todo lo que puedes lograr con BeexCC. ¡Lleva tu experiencia más lejos! ✨"
        }}
      </p>
    </template>
  </RestrictionChangePlanModal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { PlanType, PlanEspecial, PlanTypeText } from "@/app/common/types";

/**
 * Variante única del modal de restricción de API Cloud, compartida por
 * *Ajustes de plataforma → API Key, MCP y Callback* y *Planes y facturación → API Calls*.
 * Centralizar aquí el copy evita dos fuentes de verdad para el mismo texto.
 */
const props = withDefaults(
  defineProps<{
    open: boolean;
    /**
     * `CustomerPlanConfig.plan`: 1–3 Digital/Voice/Digital + Voice,
     * 4 All in One, 5 Especial.
     */
    plan?: number | null;
  }>(),
  {
    open: false,
    plan: null,
  }
);

const emit = defineEmits(["update:open"]);

const store = useStore();
const user = computed(() => store.getters["getDataUser"]);
const isClientBeexcc = computed(() => user.value?.is_beexcc);

const isSpecialPlan = computed(() => props.plan === PlanEspecial);
// Especial no es "upgrade": su vía es personalizar, igual que All in One.
const isUpgradePlan = computed(
  () => !isSpecialPlan.value && props.plan !== PlanType.AllInOne
);
// Toda variante de Personalizar (Especial y All in One) se resuelve contactando a un asesor.
// El botón "Personalizar plan" pertenece únicamente al flujo de upgrade.
const advisorOnly = computed(() => !isUpgradePlan.value);
const planName = computed(() => PlanTypeText[props.plan as PlanType]);
</script>
